'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _config = require('../config');

var _callApi = require('../callApi');

exports.default = (0, _callApi.callApiFactory)(4);


//////////////////
// WEBPACK FOOTER
// ./~/@hailtrace/client-api/dist/legacy/v4/callApi.js
// module id = 748
// module chunks = 0